/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CallExecutionRecord } from './CallExecutionRecord';
import {
    CallExecutionRecordFromJSON,
    CallExecutionRecordFromJSONTyped,
    CallExecutionRecordToJSON,
    CallExecutionRecordToJSONTyped,
} from './CallExecutionRecord';

/**
 * 
 * @export
 * @interface FindAllCallExecutions200Response
 */
export interface FindAllCallExecutions200Response {
    /**
     * 
     */
    data?: Array<CallExecutionRecord>;
}

/**
 * Check if a given object implements the FindAllCallExecutions200Response interface.
 */
export function instanceOfFindAllCallExecutions200Response(value: object): value is FindAllCallExecutions200Response {
    return true;
}

export function FindAllCallExecutions200ResponseFromJSON(json: any): FindAllCallExecutions200Response {
    return FindAllCallExecutions200ResponseFromJSONTyped(json, false);
}

export function FindAllCallExecutions200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllCallExecutions200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(CallExecutionRecordFromJSON)),
    };
}

export function FindAllCallExecutions200ResponseToJSON(json: any): FindAllCallExecutions200Response {
    return FindAllCallExecutions200ResponseToJSONTyped(json, false);
}

export function FindAllCallExecutions200ResponseToJSONTyped(value?: FindAllCallExecutions200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(CallExecutionRecordToJSON)),
    };
}

